import {
  AlgorithmSaddleIcon,
  HorseIcon,
  SaddleIcon,
  SaddleTechIconSvg,
  MobileDevIcon
} from "components/Icons";


export const featureCardData = [
  {
    title: "Find the Best Fitting Saddle",
    description:
      "Scan your horse, then find the saddle that fits best through the SaddleFit online marketplace.",
    icon: <SaddleIcon />,
  },
  {
    title: "SaddleFit Score",
    description:
      "Easy to understand 0 to 100 score based on how well your saddle fits your horse.",
    icon: <AlgorithmSaddleIcon />,
  },
  {
    title: "Improve Equine Performace",
    description:
      "When hundredths of a second matter, give yourself the advantage with a properly fitting saddle.",
    icon: <SaddleTechIconSvg />,
  },
  {
    title: "Improve Equine Health",
    description:
      "Reduce the changes of lameness and health issues with a properly fitting saddle.",
    icon: <HorseIcon />,
  },
  {
    title: "Technology Based Saddle Fitting",
    description:
      "SaddleFit.io is based on 30+ years of saddle fitting experience and research.",
    icon: <MobileDevIcon/>,
  }
];
